
import { jwtDecode } from "jwt-decode";
import { useLoginStore, useAdminStore, useOperatorStore } from "@/store";

let loadedSession = null;

function UserNotAllowed() {
  const loginStore = useLoginStore();

  loginStore.removeTokens();
  loadedSession = null;
  return "/login";
}

export const routerGuard = async (to) => {
  const storedType = localStorage.getItem("userType");
  const userType = ["admin", "operator"].includes(storedType) ? storedType : "admin";

  const loginStore = useLoginStore();
  if (to.path === "/login") return true;

  try {
    loginStore.setTokens();

    let accessToken = loginStore.getAccessToken;
    const refreshToken = loginStore.getRefreshToken;

    if (!accessToken && !refreshToken) return "/login";

    const sessionKey = `${userType}:${accessToken}`;

    if (accessToken && loadedSession === sessionKey) {
      return true;
    }

    if (accessToken) {
      const response = await loginStore.validateAccessToken(userType);
      if (!response?.success) {
        accessToken = null;
      }
    }

    if (!accessToken) {
      if (!refreshToken) {
        return UserNotAllowed();
      }

      const response = await loginStore.validateRefreshToken(userType);

      if (!(response?.status || response?.success) || !response?.accessToken) {
        return UserNotAllowed();
      }

      accessToken = response.accessToken;

      loginStore.setAccessToken(accessToken);

      if (response.refreshToken) {
        loginStore.setRefreshToken(response.refreshToken);
      }
    }

    const decoded = jwtDecode(accessToken);

    const userId = userType === "admin" ? decoded?.userId : decoded?.id;

    if (!userId) {
      return UserNotAllowed(); 
    }

    const response = userType === "admin" ? await useAdminStore().getAdminDetails(userId) : await useOperatorStore().getOperatorById(userId);
    const userDetails = userType === "admin" ? response?.data?.[0] : response?.data;

    if ( !response?.status || response.status === 404 || !userDetails) {
      return UserNotAllowed();
    }

    loginStore.setLoginDetails(userDetails);
    loadedSession = `${userType}:${accessToken}`;
    return true;
  } catch (error) {
    return UserNotAllowed();
  }
};